import React from 'react';

interface ConditionalWrapperProps {
    condition: boolean;
    classList?: string;
    children: React.ReactNode;
}

export const ConditionalWrapper: React.FC<ConditionalWrapperProps> = ({ condition, classList, children }) => {
    return condition ? <article className={classList ? classList : ''}>{children}</article> : <>{children}</>;
};
export default ConditionalWrapper;
